export const USER = 'user'
export const EXAMINATION = 'examination'
export const CERTIFICATION = 'certification'

export default {
  USER,
  EXAMINATION,
  CERTIFICATION
}
